export const PARTNERS_CHANGED_EVENT = "dashboard:partners-changed";

export const notifyPartnersChanged = (): void => {
  window.dispatchEvent(new CustomEvent(PARTNERS_CHANGED_EVENT));
};
